import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { checks } from "@/lib/validation";
import { Section } from "@/components/ui-brand";

import { Field } from "@/components/panel";

export default function Reset() {
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [email, setEmail] = useState(null);
  const [invite, setInvite] = useState(false);
  const [err, setErr] = useState(null);
  const [error, setError] = useState("");
  const [pw, setPw] = useState({ p1: "", p2: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setError("Falta el token en el enlace."); return; }
    api.get(`/auth/reset/${token}`).then((r) => { setEmail(r.data.email); setInvite(!!r.data.invitacion); })
      .catch((e) => setError(e.response?.data?.detail || "El enlace es inválido o venció."));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    const msg = checks.password(pw.p1) || checks.match(pw.p1, pw.p2);
    setErr(msg);
    if (msg) return toast.error(msg);
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw.p1 });
      toast.success(invite ? "Contraseña creada. Ya podés ingresar." : "Contraseña actualizada. Iniciá sesión con la nueva.");
      navigate("/ingresar");
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo restablecer la contraseña");
    } finally { setBusy(false); }
  };

  if (error) return (
    <Section className="py-14 max-w-md">
      <div className="card-brand p-7" data-testid="reset-error">
        <h1 className="h-section text-xl mb-2">Enlace no válido</h1>
        <p className="text-sm text-[var(--brand-text-muted)]">{error}</p>
        <button onClick={() => navigate("/ingresar")} className="btn-outline text-sm mt-4">Volver a ingresar</button>
      </div>
    </Section>
  );
  if (email === null) return <Section className="py-14 max-w-md"><p className="font-heading text-[var(--brand-primary)]">Cargando…</p></Section>;

  return (
    <Section className="py-14 max-w-md">
      <div className="card-brand p-7 sm:p-8" data-testid="reset-form">
        <h1 className="h-section text-2xl mb-1" data-testid="reset-title">{invite ? "Creá tu contraseña" : "Restablecer contraseña"}</h1>
        <p className="text-sm text-[var(--brand-text-muted)] mb-6">{email}</p>
        <form onSubmit={submit} noValidate className="space-y-3">
          <Field label="Nueva contraseña" type="password" value={pw.p1} onChange={(e) => setPw({ ...pw, p1: e.target.value })} placeholder="Mín. 8 caracteres, con letras y números" data-testid="reset-password" />
          <Field label="Repetir nueva contraseña" type="password" error={err} value={pw.p2} onChange={(e) => setPw({ ...pw, p2: e.target.value })} data-testid="reset-password-2" />
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="reset-submit">{busy ? "Guardando…" : "Guardar nueva contraseña"}</button>
        </form>
      </div>
    </Section>
  );
}
